import {Action, Module} from 'vuex-module-decorators'
import store, {alertModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import BaseModule from "@/store/modules/BaseModule";

const documentationClient = new MdbsCore.DocumentationClient();

@Module({namespaced: true, name: 'documentation', store: store})
export default class DocumentationModule extends BaseModule {

    @Action({rawError: true})
    async getFunctionalDesign(payload: { studyDefinitionId: string, languageIdentifier: string }){
        await this.startLoading()

        try {
            let response =  await documentationClient.getFunctionalDesign(payload.studyDefinitionId, payload.languageIdentifier);
            if (!response.fileName)
                response.fileName = this.getFileName(response);

            return response;
        } catch (e) {
            await alertModule.handleException(e);
        } finally {
            this.stopLoading()
        }
    }

    @Action({rawError: true})
    async getAnnotatedEcrf(payload: { studyDefinitionId: string, languageIdentifier: string }){
        await this.startLoading()
        try {
            let response =  await documentationClient.getAnnotatedEcrf(payload.studyDefinitionId, payload.languageIdentifier);
            if (!response.fileName)
                response.fileName = this.getFileName(response);

            return response;
        } catch (e) {
            await alertModule.handleException(e);
        } finally {
            this.stopLoading()
        }
    }

    @Action({rawError: true})
    async getAnnotatedEcrfView(payload: { studyDefinitionId: string, languageIdentifier: string }){
        await this.startLoading()
        try {
            return await documentationClient.getAnnotatedEcrfView(payload.studyDefinitionId, payload.languageIdentifier);
        } catch (e) {
            await alertModule.handleException(e);
        } finally {
            this.stopLoading()
        }
    }

    @Action({rawError: true})
    async getCompleteDocumentation(payload: { studyDefinitionId: string, languageIdentifier: string }){
        await this.startLoading()

        try {
            let response =  await documentationClient.getComplete(payload.studyDefinitionId, payload.languageIdentifier);
            if (!response.fileName)
                response.fileName = this.getFileName(response);

            return response;
        } catch (e) {
            await alertModule.handleException(e);
        } finally {
            this.stopLoading()
        }
    }

    private getFileName(response: MdbsCore.FileResponse) {
        var contentDisposition = response?.headers?.get('Content-Disposition');
        let fileName = contentDisposition?.split(';')[1].split('filename')[1].split('=')[1].replace(/"/g, '').trim();
        return fileName;
    }
}
